import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=2476393b&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476393b",
  null
  
)

export default component.exports